// Notification sound generator using Web Audio API
// Produces elegant, non-intrusive chime sounds

let audioCtx = null;

function getAudioCtx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

/**
 * Play an urgent notification sound — two rising tones (attention-grabbing but elegant)
 */
export function playUrgentSound() {
  try {
    const ctx = getAudioCtx();
    const now = ctx.currentTime;

    // First tone — higher pitch
    playTone(ctx, 880, now, 0.12, 0.15);
    // Second tone — even higher
    playTone(ctx, 1100, now + 0.15, 0.15, 0.12);
    // Third accent
    playTone(ctx, 1320, now + 0.32, 0.08, 0.08);
  } catch (e) {
    // Audio not available — silent fallback
  }
}

/**
 * Play an error notification sound — descending tone (alert but not alarming)
 */
export function playErrorSound() {
  try {
    const ctx = getAudioCtx();
    const now = ctx.currentTime;

    playTone(ctx, 660, now, 0.1, 0.12);
    playTone(ctx, 440, now + 0.12, 0.15, 0.1);
  } catch (e) {
    // Silent fallback
  }
}

/**
 * Play a gentle suggestion notification — single soft chime
 */
export function playSuggestionSound() {
  try {
    const ctx = getAudioCtx();
    const now = ctx.currentTime;

    playTone(ctx, 784, now, 0.08, 0.2); // G5 - gentle
  } catch (e) {
    // Silent fallback
  }
}

function playTone(ctx, frequency, startTime, attack, release) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = 'sine';
  osc.frequency.setValueAtTime(frequency, startTime);

  // Smooth envelope
  gain.gain.setValueAtTime(0, startTime);
  gain.gain.linearRampToValueAtTime(0.15, startTime + attack);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + attack + release);

  osc.connect(gain);
  gain.connect(ctx.destination);

  osc.start(startTime);
  osc.stop(startTime + attack + release + 0.05);
}
